export default __webpack_public_path__ + "static/media/tokyostationyakiudon.3827331d.jpeg";